module.exports = __webpack_public_path__ + "img/landscape_7.cf109afc.jpg";